export default __webpack_public_path__ + "static/media/SconeProductInfo4.3d403799.jpg";